import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import {
  CsrfProvider,
  initializeApp,
  LibContext,
} from 'framework-react-core';
import App from './App';

await initializeApp({
  staticConfig: {
    FRAMEWORK_UI_APPLICATION_NAME: 'CLA Quiz Builder',
    FRAMEWORK_UI_NAVBAR: [],
    FRAMEWORK_UI_APP_INSIGHTS: { connectionString: '' },
    FRAMEWORK_UI_CSRF: { enabled: false },
    FRAMEWORK_UI_LOGGER: {
      minLogLevel: 'debug',
      enabledTargets: { console: true, appInsights: false },
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <LibContext>
      <CsrfProvider>
        <App />
      </CsrfProvider>
    </LibContext>
  </StrictMode>,
);
